export default __webpack_public_path__ + "static/media/Hide.334f1440.svg";